/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { withTranslation } from "react-i18next";
import styles from "./ReviewSummaryView.module.scss";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { humanReadableDate } from "../../../../helpers/utils";

const PersonalInfoSummary = ({ t, i18n, setIsError }) => {
  const navigate = useNavigate();

  const { personalInformation } = useSelector((state) => state.app);
  const {
    firstName,
    lastName,
    socialInsuranceNumber,
    dateOfBirth,
    email,
    phone,
    altPhone,
    textAllowedAtPhoneNumber
  } = personalInformation;

  const dob =
    i18n.language === "fr"
      ? new Date(dateOfBirth).toLocaleString("fr-FR", {
        month: "long",
        day: "numeric",
        year: "numeric"
      })
      : humanReadableDate(dateOfBirth);

  const editPersonalInfoOnClick = (e) => {
    e.preventDefault();
    try {
      navigate(
        `/${i18n.language}${t("routes.personal_information")}?isSummary=true`
      );
    } catch (e) {
      console.log(e);
      setIsError(true);
    }
  };

  return (
    <div className="row">
      <div className="col-xs-12 col-lg-9">
        <div className="col-xs-12">
          <div className="row" style={{ display: "flex", flexWrap: "wrap" }}>
            <div
              style={{
                display: "flex",
                flexGrow: 1,
                justifyContent: 'flex-start',
                alignItems: "center"
              }}
            >
              <div style={{ margin: '0px 6px' }}>
                <h3>{t("review_summary.personal_information")}</h3>
              </div>
              <div style={{ margin: '0px 1em' }}>
                <a
                  id="edit-your-info"
                  href="#"
                  className={[styles["edit_button"]].join(" ")}
                  onClick={editPersonalInfoOnClick}
                  value={t("shared.edit")}
                  name={t("shared.edit")}
                >
                  <i
                    aria-label={t("shared.edit")}
                    className="fa fa-pencil-alt"
                    aria-hidden="true"
                  ></i>
                  {t("shared.edit")}
                </a>
              </div>
            </div>
          </div>

          {/*  Personal Info */}
          <div className="row" style={{ display: "flex", flexWrap: "wrap" }}>
            <div className="col-xs-12 col-md-6">
              <strong>
                {t("review_summary.personal_information_section1")}
              </strong>
            </div>
            <div className="col-xs-12 col-md-6">
              {`${firstName} ${lastName}`}
            </div>
          </div>
          <hr />

          <div className="row" style={{ display: "flex", flexWrap: "wrap" }}>
            <div className="col-xs-12 col-md-6">
              <strong>
                {t("review_summary.personal_information_section3")}
              </strong>
            </div>
            <div className="col-xs-12 col-md-6">{dob}</div>
          </div>
          <hr />

          <div className="row" style={{ display: "flex", flexWrap: "wrap" }}>
            <div className="col-xs-12 col-md-6">
              <strong>
                {t("review_summary.personal_information_section2")}
              </strong>
            </div>
            <div className="col-xs-12 col-md-6">
              {`xxx xxx ` +
                socialInsuranceNumber.substr(socialInsuranceNumber.length - 3)}
            </div>
          </div>
          <hr />

          <div className="row" style={{ display: "flex", flexWrap: "wrap" }}>
            <div className="col-xs-12 col-md-6">
              <strong>
                {t("review_summary.personal_information_section7")}
              </strong>
            </div>
            <div className="col-xs-12 col-md-6">{email}</div>
          </div>
          <hr />

          <div className="row" style={{ display: "flex", flexWrap: "wrap" }}>
            <div className="col-xs-12 col-md-6">
              <strong>
                {t("review_summary.personal_information_section4")}
              </strong>
            </div>
            <div className="col-xs-12 col-md-6">{phone}</div>
          </div>
          <hr />

          <div className="row" style={{ display: "flex", flexWrap: "wrap" }}>
            <div className="col-xs-12 col-md-6">
              <strong>
                {t("review_summary.personal_information_section8")}
              </strong>
            </div>
            <div className="col-xs-12 col-md-6">
              {textAllowedAtPhoneNumber === true
                ? t("shared.yes")
                : t("shared.no")}
              { }
            </div>
          </div>
          <hr />

          <div className="row" style={{ display: "flex", flexWrap: "wrap" }}>
            <div className="col-xs-12 col-md-6">
              <strong>
                {t("review_summary.personal_information_section6")}
              </strong>
            </div>
            <div className="col-xs-12 col-md-6">
              {altPhone ? altPhone : "N/A"}
            </div>
          </div>
          <hr />
        </div>
      </div >
    </div >
  );
};

export default withTranslation("common")(PersonalInfoSummary);
